/* eslint-disable default-param-last */
import { types, actions } from './actions'

const initialState: DashboardState = { graph: 'Donors', chartStyle: 'bar' }

type SupportedActions = ActionsUnion<typeof actions>

export const reducer = (state: DashboardState = initialState, action: SupportedActions): DashboardState => {
    switch (action.type) {
        case types.ASSIGN_DASHBOARD_SETTINGS:
            return {
                ...state,
                instanceSettings: action.payload as DashboardSettingsDto,
            }
        case types.POPULATE_DASHBOARD_DATA:
            return {
                ...state,
                data: action.payload as CampaignDashboardDataContainer,
            }
        case types.SHOW_DOLLARS:
            return {
                ...state,
                graph: 'Dollars',
            }
        case types.SHOW_DONORS:
            return {
                ...state,
                graph: 'Donors',
            }
        case types.SHOW_LINE:
            return {
                ...state,
                chartStyle: 'line',
            }
        case types.SHOW_BAR:
            return {
                ...state,
                chartStyle: 'bar',
            }
        case types.UPDATE_LEGEND:
            return {
                ...state,
                selected: action.payload,
            }
    }
    return state
}
